module.exports = __webpack_public_path__ + "img/cup-mascot-news.4bc8b13b.png";